// extracted by mini-css-extract-plugin
var _1 = "zLV0ES0UcraMz5J8mjlM";
var _2 = "JaIIbjEFVtfJfxaE84oi";
var _3 = "rbGzCZfd400WWub7hmeE";
var _4 = "PQeHwltVwmQNdBrNtYyi";
var _5 = "TrrLXmvegiyOu6xNjKnO";
var _6 = "olQDtfiyVR7wpPnNXgR7";
var _7 = "hASgaD3d9QUO_q9ffMlZ";
export { _1 as "container", _2 as "content", _3 as "svg", _4 as "wedgeBottomLeft", _5 as "wedgeBottomRight", _6 as "wedgeTopLeft", _7 as "wedgeTopRight" }
